import * as R from "ramda";

export const sumFees = (fees) => R.sum(R.map(parseFloat, R.pluck("cost", fees)));
export const getName = R.prop("name");
export const getRequirementID = R.prop("requirement_id");

export const getFeesWithCosts = R.curry((feeTotals, fees) =>
  fees.map((fee) => {
    const cost = feeTotals[fee.id] || 0;
    return { ...fee, cost: Number(cost) };
  }),
);

export const getFeeCost = (record, fee) => R.path(["fees", fee.id], record);
